import React from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import ReimbursementsReceivedActions from '../../redux/reducers/reimbursements_received_list_reducer/actions';
import useStyles from './styles';
import ReimbursementsReceivedDatatableList from './components/datatable';
import clsx from 'clsx';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { Translations } from './configuration';
import { ReimbursementsReceivedTableDefaultFetchValues } from './components/datatable/configuration';
import NavigationConfig from 'navigation/config';
import ReimbursementsReceivedListActions from 'redux/reducers/reimbursements_received_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';

const ReimbursementsReceivedPage = (props: any) => {
  // console.log('Render ReimbursementsReceived Page');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const originatingCountry = query.get('originatingCountry');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(originatingCountry && { originatingCountry }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(
      ReimbursementsReceivedListActions.fetchMemberStateExcludeCyprusAction()
    );
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      ReimbursementsReceivedActions.fetchUnreadNotificationCountAction()
    );
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      ReimbursementsReceivedActions.fetchReimbursementsReceivedListAction({
        sortField:
          ReimbursementsReceivedTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: ReimbursementsReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          ReimbursementsReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order:
          ReimbursementsReceivedTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== ReimbursementsReceived Page ==================*/
    <div>
      {/*================== ReimbursementsReceived Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* ReimbursementsReceived Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <CreditCardIcon style={{ marginRight: '.75rem' }} />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of ReimbursementsReceived Page - Header ---------------*/}

      {/*================== ReimbursementsReceived Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== ReimbursementsReceived Page - Body - ReimbursementsReceived Section ==================*/}
        <div className={classes.cardLayout}>
          {/* ReimbursementsReceived Page - Body - ReimbursementsReceived Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* ReimbursementsReceived Page - Body - ReimbursementsReceived Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* ReimbursementsReceived Page - Body - ReimbursementsReceived Section - ReimbursementsReceived List Table */}
          <div className={classes.tableList}>
            <ReimbursementsReceivedDatatableList />
          </div>

          {/* ReimbursementsReceived Page - Body - ReimbursementsReceived Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of ReimbursementsReceived Page - Body - ReimbursementsReceived Section ---------------*/}
      </div>
      {/*--------------- end of ReimbursementsReceived Page - Body ---------------*/}
    </div>
    /*--------------- end of ReimbursementsReceived Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(ReimbursementsReceivedPage);
